import { UserDetailScreen } from "@/screens/user/UserDetailScreen";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/users/$userId")({
  component: UserDetailScreen,
  loader: () => {
    return {
      crumb: `Detail Pengguna`,
    };
  },
});
